// import Fallback from '../../Fallback'

import { useNavigate } from "react-router"
import WindowsVersionsList from "../WindowsVersionsList"
import { Chip, Typography } from "@podcastsoundboard/ps-lib/ui"

export default function WindowsVersionsContent() {
  const navigate = useNavigate()
  return (
    <>
      <Typography variant="h2" className="mb-4">
        Downloads
      </Typography>
      <Typography
        variant="body1"
        style={{ fontSize: "1.5rem" }}
        className="mb-4"
      >
        A perpetual license key or active cloud subscription is required to use
        the windows app.
      </Typography>

      <Chip
        size="medium"
        clickable
        variant="outlined"
        onClick={() => navigate("/app/windows/changelog")}
        label="Changelog"
      />

      <WindowsVersionsList />
    </>
  )
}
